module.exports = __webpack_public_path__ + "static/media/Vestas_Picture4.5e147014.png";